import { useCallback } from 'react';
import { ENTRYPOINT_ID_JIRA_COMMAND_PALETTE } from '@atlassian/jira-feedback-collector/src/constants.tsx';
import { useFeedbackCollectorActions } from '@atlassian/jira-feedback-collector/src/controllers/index.tsx';
import type { FeedbackCollectorProps } from '@atlassian/jira-feedback-collector/src/types.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages.tsx';

export const useCommandPaletteFeedbackCollector = () => {
	const { openFeedbackCollector, resetFeedbackCollectorState } = useFeedbackCollectorActions();
	const { formatMessage } = useIntl();

	const openCommandPaletteFeedbackCollector = useCallback(
		(props?: Partial<FeedbackCollectorProps>) => {
			openFeedbackCollector({
				entrypointId: ENTRYPOINT_ID_JIRA_COMMAND_PALETTE,
				feedbackTitle: formatMessage(messages.feedbackTitle),
				...props,
			});
		},
		[formatMessage, openFeedbackCollector],
	);

	return [openCommandPaletteFeedbackCollector, resetFeedbackCollectorState];
};
